<template>
    <BasePanel
        :headline="$t('lang_ACCOUNTS_MAPPINGS_CAPTION_COLUMN_MAPPINGS_PANEL')"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                hide-default-footer
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :items-per-page="100"
            >
            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

                <!-- Items -->
                <template v-slot:[`item.columnNumber`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-column-number'" class="ellipsis">
                        {{ item.templateColumn }}
                    </div>
                </template>

                <template v-slot:[`item.entityName`]="{ item }">
                    <div :alvqa="`${alvqa}-list-row-${item.id}-text-item-name`" class="ellipsis">
                        {{ $t(getItemName(item.entityName)) }}
                    </div>
                </template>

                <template v-slot:[`item.alvField`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-alv-field'" class="ellipsis">
                        {{ $t(getAlvFieldName(item)) }}        
                    </div>
                </template>

                <template v-slot:[`item.formula`]="{ item }">
                    <BaseTooltip
                        :alvqa="alvqa + '-list-row-' + item.id + '-text-formula'"
                    >
                        <template v-slot:content>
                            <div class="ellipsis">
                                {{ item.formula }}
                            </div>
                        </template>
                        <template v-slot:text>
                            {{ item.formula }}
                        </template>
                    </BaseTooltip>
                </template>

            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'

import 
    { 
        DropdownAccountMappingsAlvFields,
        DropdownAccountMappingsDomainsOptions
    } 
from '@/assets/dropdowns/alvDropdowns.js'
import BaseTooltip from "@/components/_base/BaseTooltip.vue";

export default {
    name: 'MappingsColumnMappingsReadOnlyPanel',
    components: {
        BaseTooltip,
        BasePanel
    },
    props: {
        mappingsAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'mappings-list-row-' + this.mappingsAlvId + '-read-only-panel-column-mappings'
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t('lang_ACCOUNTS_MAPPINGS_CAPTION_TEMPLATE_COLUMN'), 
                    value: 'templateColumn',
                    align: 'left', 
                    sortable: true,
                    class: 'text-no-wrap',
                    width: '220px',
                    alvqa: this.alvqa + '-header-template-column'
                }, 
                {
                    text: this.$t('lang_ACCOUNT_MAPPINGS_CAPTION_ITEM'),
                    value: 'entityName',
                    align: 'left',
                    sortable: true,
                    class: 'text-no-wrap',
                    width: '220px',
                    alvqa: this.alvqa + '-header-item-name'
                },
                {
                    text: this.$t('lang_ACCOUNTS_MAPPINGS_CAPTION_ALV_FIELD'), 
                    value: 'alvField', 
                    align: 'left', 
                    sortable: false,
                    class: 'text-no-wrap',
                    width: '200px',
                    alvqa: this.alvqa + '-header-alv-field'
                }, 
                {
                    text: this.$t('lang_ACCOUNTS_MAPPINGS_CAPTION_FORMULA'), 
                    value: 'formula',
                    align: 'left', 
                    sortable: true,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-formula'
                }, 
            ]
        },
        listItems() {
            return this.$store.getters.getColumnMappings 
        },
        listItemsLength() {
            return this.$store.getters.getMappingsColumnMappings.length 
        }
    },

    methods: {
        getAlvFieldName(item) {
            let allAlvFields    = DropdownAccountMappingsAlvFields
            let domain          = item.entityName ? item.entityName : this.$store.getters.getMappingsDetailsDomain
            let direction       = this.$store.getters.getMappingsDetailsDirection  
            let alvFields       = allAlvFields[direction + "_" + domain]
            if(alvFields !== undefined) {
                let res = alvFields.find(field => {
                    return field.value === item.alvField
                })
                return res ? res.text : ''
            }
        },
        getItemName(itemName) {
            let rootDomain = this.$store.getters.getMappingsDetailsDomain
            if (rootDomain == 'publishing_works') {
                let options = [
                    {
                        value: 'publishing_works',
                        text: 'lang_PUBLISHING_CAPTION_WORKS'
                    },
                    {
                        value: 'publishing_works_interested_parties',
                        text: 'lang_PUBLISHING_WORKS_CAPTION_INTERESTED_PARTIES'
                    },
                    {
                        value: 'publishing_works_work_ids',
                        text: 'lang_GENERIC_CAPTION_OTHER_IDS'
                    },
                    {
                        value: 'publishing_works_instrumentations',
                        text: 'lang_PUBLISHING_WORKS_CAPTION_INSRUMENTATION'
                    },
                    {
                        value: 'publishing_works_other_titles',
                        text: 'lang_PUBLISHING_WORKS_CAPTION_OTHER_TITLES'
                    },
                    {
                        value: 'publishing_works_contracts',
                        text: 'lang_GENERIC_CAPTION_CONTRACTS'
                    }
                ]
                
                let foundItem = options.find((v) => v.value === itemName)

                return foundItem ? foundItem.text : ''
            }

            let options = DropdownAccountMappingsDomainsOptions
            // find root domain from dropdown options and return it as single item array
            return options.find((v) => v.direction === 'import' && rootDomain === v.value).text
        }
    },
}
</script>